import React from 'react';
import { useApp } from '../context/AppContext';
import Icon from './Icon';
import './MobileNav.css';

const TABS = [
  { key: 'home', icon: 'sparkle', label: '首頁' },
  { key: 'category', icon: 'gem', label: '分類', params: { id: 'all' } },
  { key: 'search', icon: 'search', label: '搜尋', drawer: 'search' },
  { key: 'cart', icon: 'cart', label: '購物車', drawer: 'cart' },
  { key: 'account', icon: 'user', label: '會員', drawer: 'account', authRequired: true },
];

export default function MobileNav() {
  const { route, navigate, openDrawer, cartCount, user } = useApp();

  const onTap = (tab) => {
    if (tab.drawer) {
      if (tab.authRequired && !user) {
        openDrawer('auth');
      } else {
        openDrawer(tab.drawer);
      }
    } else {
      navigate(tab.key, tab.params);
    }
  };

  return (
    <nav className="mnav" aria-label="底部導航">
      {TABS.map((tab) => {
        const active =
          (tab.key === 'home' && route.page === 'home') ||
          (tab.key === 'category' && route.page === 'category');
        return (
          <button
            key={tab.key}
            type="button"
            className={`mnav__tab ${active ? 'is-active' : ''}`}
            onClick={() => onTap(tab)}
          >
            <span className="mnav__icon">
              <Icon name={tab.icon} size={20} />
              {tab.key === 'cart' && cartCount > 0 && (
                <span className="mnav__badge">{cartCount}</span>
              )}
            </span>
            <span className="mnav__label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
